import { app } from '@/main';
import flagKeys from '@/constants/flagKeys';
import { EBillingStatusTypes } from '@/store/modules/businessTypes';

// Whether the portal should show billing at all, independent of the business's
// own subscription state — the two are separate questions and each billing
// surface answers them differently (TWISM-18850).
export const getBillingIsHidden = () => {
  const flags = app.$store.getters['flags/getFlags'] || [];

  return flags.includes(flagKeys.hideBillingInterface);
};

// The migrated cohort: businesses TWISM-18928 moved to the free plan. They keep
// a reduced Coin Network Plan screen while the flag is on, so they can still read
// their Coin history. The backend owns the rule; the portal only reads the
// boolean off the subscription overview (TWISM-19180).
export const getHasBillingAccess = () => {
  const subscription = app.$store.getters['business/getBillingSubscription'];

  return Boolean(subscription && subscription.hasBillingAccess);
};

// Billing is unreachable: the flag is on and this business was not migrated.
export const getBillingIsBlocked = () =>
  getBillingIsHidden() && !getHasBillingAccess();

// Billing is reachable, but in the reduced free-plan form.
export const getBillingIsFreeCohort = () =>
  getBillingIsHidden() && getHasBillingAccess();

export const getBillingIsPending = () => {
  const business = app.$store.getters['business/getBusinessInfo'].business;
  const subscription = app.$store.getters['business/getBillingSubscription'];

  if (!business || !subscription) return false;

  return (
    business.subscriptionStatus === EBillingStatusTypes.PENDING &&
    !subscription.status
  );
};

export const getBillingOnboardingCallPending = () => {
  const business = app.$store.getters['business/getBusinessInfo'].business;
  const subscription = app.$store.getters['business/getBillingSubscription'];

  if (!business || !subscription) return false;

  return (
    business.subscriptionStatus === EBillingStatusTypes.PENDING &&
    subscription.status === EBillingStatusTypes.PENDING
  );
};
